import React, { ComponentClass, FC } from "react";
import { useHistory } from "react-router-dom";
import { checkIsFilmmakersProfile } from "shared-auth";
import { CommonErrorPopup } from "component-library";
import { useTranslation } from "i18n";

interface IComponentProps {
  isViewMode?: boolean;
}

export default function withFilmmakersAccessRestriction<
  T extends IComponentProps,
>(
  WrappedComponent: ComponentClass | FC<React.PropsWithChildren>
): FC<React.PropsWithChildren<T>> {
  return (props) => {
    const { goBack } = useHistory();
    const { t } = useTranslation();

    const isFilmmakersProfile = checkIsFilmmakersProfile();

    if (isFilmmakersProfile && !props?.isViewMode)
      return (
        <CommonErrorPopup
          errorStatusCode={403}
          popupProps={{
            close: goBack,
          }}
          alertMessageProps={{
            buttons: [
              {
                name: t("common:button.label.close"),
                type: "primary",
                click: goBack,
              },
            ],
          }}
        />
      );

    return <WrappedComponent {...props} />;
  };
}
